import React from 'react';
import { SIGNAL_STATUS } from '../../../utils/SignalsStatus';

type SignalDotProps = {
  value?: string;
  index?: number;
};

const SignalDot = ({ value, index }: SignalDotProps): JSX.Element => {
  let dotColor = '#6c757d';
  switch (value) {
    case SIGNAL_STATUS.POOR:
      dotColor = '#ff2a2a';
      break;
    case SIGNAL_STATUS.VERY_POOR:
      dotColor = '#1a1a1a';
      break;
    case SIGNAL_STATUS.GOOD:
      dotColor = '#ffcc00';
      break;
    case SIGNAL_STATUS.EXCELLENT:
    case SIGNAL_STATUS.VERY_GOOD:
      dotColor = 'rgb(134,204,26)';
      break;
    case SIGNAL_STATUS.FAIR:
      dotColor = 'rgba(255,122,15,0.88)';
      break;
    case SIGNAL_STATUS.UNDEFINED:
    default:
      dotColor = '#6c757d';
      break;
  }
  return (
    <div
      className={'form-inline d-flex justify-content-center align-items-center'}
      style={{ position: 'relative', height: '15px' }}
    >
      <div
        className={index ? `status-dot index-${index}` : 'status-dot'}
        style={{
          borderRadius: '50%',
          height: '10px',
          width: '10px',
          background: dotColor,
        }}
      />
    </div>
  );
};

export default React.memo(SignalDot);
SignalDot.whyDidYouRender = true;
